import { Alert, Heading } from "@instructure/ui";
import c3 from "c3";
import { t } from "i18next";
import { useEffect } from "react";
import SimpleTable from "../../../sections/Cards/SimpleTable/SimpleTable";
import { sort } from "../../../utils/utils";
import { Card } from "../../Card";

const ResultsChart = ({
  results,
  presentationType,
  masteryResults,
  courseCode,
}) => {
  useEffect(() => {
    if (results) {
      c3.generate({
        bindto: "#assessment-chart",
        data: { x: "terms", columns: results, type: presentationType },
        axis: {
          x: { type: "category" },
          y: {
            label: {
              text: masteryResults
                ? t("dashboard.percentAchievedMastery")
                : t("dashboard.avgAssignmentGrade"),
              position: "outer-middle",
            },
          },
          tick: {
            values: [0, 20, 40, 60, 80, 100],
            format: function (d) {
              return d + "%";
            },
          },
        },
        tooltip: {
          order: function (data1, data2) {
            return sort([data1, data2], (d) => d.name);
          },
        },
      });
    }
  }, [presentationType, results, masteryResults]);

  return (
    <Card style={{ height: "auto" }}>
      <Heading level="h2" border="bottom" margin="0 0 small 0">
        {t("courseReview.courseResults")}
      </Heading>
      {results ? (
        presentationType === "table" ? (
          <SimpleTable
            data={results}
            rowTitle={t("results.outcomes")}
            caption={t("courseReview.tableCaption", { code: courseCode })}
          />
        ) : (
          <div id="assessment-chart" />
        )
      ) : (
        <Alert>{t("courseReview.noResultsSelected")}</Alert>
      )}
    </Card>
  );
};

export default ResultsChart;
